import { useTranslation } from 'next-i18next';
import { useAtom } from 'jotai';

import { EmployerCollaboratorFeedbackScreen } from '@restworld/ui-components';

import { useCollaboratorActionModal, selectedCollaboratorAtom } from '../../../collaborators.atoms';

function RemoveCollaboratorSuccessScreen() {
  const { t } = useTranslation('collaborators-page');
  const { closeCollaboratorActionModal } = useCollaboratorActionModal();
  const [selectedCollaborator] = useAtom(selectedCollaboratorAtom);
  const firstName = selectedCollaborator?.user?.name;

  return (
    <EmployerCollaboratorFeedbackScreen
      title={`${firstName} ${t('has_been_successfully_removed_from_the_collaborator_list')}`}
      cta={{ title: t('back_to_collaborators'), onClick: closeCollaboratorActionModal }}
    />
  );
}
export default RemoveCollaboratorSuccessScreen;
